var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 125,
    viewBox: "0 0 100 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_887_369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 125
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.757568,
    width: 100,
    height: 124.242,
    rx: 20,
    fill: "#F8F9FE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_887_369)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.4015 6.81812C20.8484 6.81812 7.39111 20.2754 7.39111 36.8285C7.39111 53.0656 20.0902 66.207 36.6433 66.7756C37.1487 66.7124 37.6542 66.7124 38.0333 66.7756C38.1596 66.7756 38.2228 66.7756 38.3492 66.7756C38.4123 66.7756 38.4123 66.7756 38.4755 66.7756C54.6495 66.207 67.3486 53.0656 67.4118 36.8285C67.4118 20.2754 53.9545 6.81812 37.4015 6.81812Z",
    fill: "#fefefe",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.503 83.5805C51.8758 71.8291 23.1291 71.8291 5.37559 83.5805C-2.64822 88.9508 -7.0708 96.2165 -7.0708 103.988C-7.0708 111.759 -2.64822 118.961 5.31242 124.268C14.1576 130.207 25.7826 133.177 37.4077 133.177C49.0328 133.177 60.6578 130.207 69.503 124.268C77.4636 118.898 81.8862 111.695 81.8862 103.861C81.823 96.0901 77.4636 88.8876 69.503 83.5805Z",
    fill: "#fefefe",
    fillOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4a1be090b20cfb9328fd084fd1a89a83.svg";
export { ForwardRef as ReactComponent };